<template>
  <div id="forgotPasswordDiv">
    <ApopBar/>
    <b-container>
      <ResetPasswordRequest v-on:requestSubmitted="setUsername" v-if="!userName"/>
      <ResetPasswordSubmit :parentUsername="userName" v-if="userName"/>
    </b-container>
  </div>
</template>

<script>
  import ApopBar from '../components/ApopBar'
  import ResetPasswordRequest from '../components/ResetPasswordRequest'
  import ResetPasswordSubmit from '../components/ResetPasswordSubmit'

  export default {
    name: 'ForgotPassword',
    components: { ApopBar, ResetPasswordRequest, ResetPasswordSubmit },
    data () {
      return {
        userName: ''
      }
    },
    methods: {
      setUsername (e) {
        this.userName = e
      }
    }
  }

</script>

<style>

</style>
